module.exports = __webpack_public_path__ + "img/IJR_Mudancas_Fretes_f1.2a30e34c.webp";